export const DIFFERENTIAL_DIFFUSION_GENERATIVE_FILL_MODEL =
  "DIFFERENTIAL_DIFFUSION";

export const FLUX_LORA_FILL_GENERATIVE_FILL_MODEL = "FLUX_LORA_FILL";

export const DEFAULT_GENERATIVE_FILL_MODEL = "DEFAULT";

export const GENERATIVE_FILL_MODELS = [
  DIFFERENTIAL_DIFFUSION_GENERATIVE_FILL_MODEL,
  FLUX_LORA_FILL_GENERATIVE_FILL_MODEL,
  DEFAULT_GENERATIVE_FILL_MODEL,
] as const;

export const GENERATIVE_FILL_MODEL_TO_LABELS = {
  [DIFFERENTIAL_DIFFUSION_GENERATIVE_FILL_MODEL]: "Diffusion",
  [FLUX_LORA_FILL_GENERATIVE_FILL_MODEL]: "Flux",
  [DEFAULT_GENERATIVE_FILL_MODEL]: "Default",
} as const;

export const DIFFERENTIAL_DIFFUSION_GENERATIVE_FILL_CREATIVITY_STRENGTH_PRESETS =
  ["LOW", "MEDIUM", "HIGH", "CUSTOM"] as const;
